import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Check as CheckIcon,
} from '@mui/icons-material';
import { BRAND, brandAlpha } from '../../theme/brandTokens';

const backButtonSx = {
  borderRadius: 2,
  px: { xs: 2, sm: 4 },
  py: 1.5,
  minHeight: 48,
  width: { xs: '100%', sm: 'auto' },
  whiteSpace: 'nowrap',
  borderColor: BRAND.accent,
  color: BRAND.accentText,
  fontWeight: 600,
  '&:hover': {
    borderColor: BRAND.accentDark,
    backgroundColor: brandAlpha('accent', 0.1),
  },
  '&:disabled': {
    borderColor: brandAlpha('accent', 0.3),
    color: brandAlpha('accent', 0.3),
  },
};

const nextButtonSx = {
  borderRadius: 2,
  px: { xs: 2, sm: 4 },
  py: 1.5,
  minHeight: 48,
  width: { xs: '100%', sm: 'auto' },
  whiteSpace: 'nowrap',
  fontWeight: 700,
  background: BRAND.accent,
  color: BRAND.onAccent,
  boxShadow: 'none',
  '&:hover': {
    background: BRAND.accentDark,
    boxShadow: 'none',
  },
  '&:disabled': {
    background: '#ccc',
    transform: 'none',
    boxShadow: 'none',
  },
};

export default function WizardStepNavigation({
  id,
  backId,
  nextId,
  backLabel,
  nextLabel,
  onBack,
  onNext,
  backDisabled = false,
  nextDisabled = false,
  isLastStep = false,
  nextLoading = false,
}) {
  return (
    <Box
      id={id}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'stretch',
        gap: 1.5,
        mt: 4,
        pt: 3,
        borderTop: '1px solid rgba(0,0,0,0.1)',
      }}
    >
      <Button
        id={backId}
        variant="outlined"
        onClick={onBack}
        disabled={backDisabled}
        startIcon={<ArrowBackIcon />}
        sx={backButtonSx}
      >
        {backLabel}
      </Button>

      <Button
        id={nextId}
        variant="contained"
        onClick={onNext}
        disabled={nextDisabled}
        endIcon={isLastStep
          ? (nextLoading ? <CircularProgress size={20} color="inherit" /> : <CheckIcon />)
          : (nextLoading ? <CircularProgress size={20} color="inherit" /> : <ArrowForwardIcon />)}
        sx={nextButtonSx}
      >
        {nextLabel}
      </Button>
    </Box>
  );
}
